"use strict";
var CompileBinding = (function () {
    function CompileBinding(node, sourceAst) {
        this.node = node;
        this.sourceAst = sourceAst;
    }
    return CompileBinding;
}());
exports.CompileBinding = CompileBinding;
//# sourceMappingURL=compile_binding.js.map


/*****************
 ** WEBPACK FOOTER
 ** /var/www/smartwifi/shared/~/@angular/compiler/src/view_compiler/compile_binding.js
 ** module id = 174
 ** module chunks = 0 1 2
 **/